import * as React from "react";
import { SVGProps } from "react";

const Siacoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 404 404" {...props}>
    <path
      fill="#20ee82"
      d="M262.65 202v60.6H202a60.6 60.6 0 1 1 60.6-60.6m-59.8-101a101 101 0 1 0-6 202H303v-99.8c0-55.7-44.5-101.8-100.2-102.2"
    />
    <path
      fill="#7f8c8d"
      d="M344.85 59.17a202 202 0 0 0-254.2-25.7 40.5 40.5 0 0 1 5.8 8.3 192.2 192.2 0 0 1 241.2 24.6c74.8 74.7 74.8 196.4 0 271.2s-196.5 74.8-271.3 0a192.2 192.2 0 0 1-24.5-241.2 40.1 40.1 0 0 1-8.3-5.8c-61.55 93-36 218.37 57 279.92s218.37 36 279.92-57a202 202 0 0 0-25.62-254.32"
    />
    <path
      fill="#20ee82"
      d="M46.45 46.37a20.2 20.2 0 1 1 .07 28.57l-.07-.07a20.2 20.2 0 0 1 0-28.5"
    />
  </svg>
);

export default Siacoin;
